import formComponent from '@/util/proto/formComponent'
import { str2time } from '@/util/format/duration'
const isPromise = v => Object.prototype.toString.call(v) == '[object Promise]' 

export default {
  extends: formComponent ,

  props:['validator'],

  data() {
    const rangeValidator = (rule , value , callback) => {
      if( this.validator && typeof this.validator === 'function' ){
        let process = this.validator(value.map(str2time))
        if( isPromise(process) ){
          process.then(resp => {
            if( resp ){
              callback()
            }else{
              callback(new Error('与已有时段重叠，请重新选择'))
            }
          })
        }else{
          if( process !== false){
            callback()
          }else{
            callback(new Error('与已有时段重叠，请重新选择'))
          }
        }
      }else{
        callback()
      }
    }

    return {
      loading:false,
      repairUsers:[],
      formData: {
        range: {
          rules:[
            { required: true, type:'array',message: '请选择时段', trigger: 'blur,change' },
            { validator: rangeValidator, trigger: 'blur,change' },
          ]
        },
        price:{
          rules:[
            { required: true, type:'number' ,  message: '请输入价格', trigger: 'blur,change' },
          ]
        }
      }
    }
  },

  methods:{
    save(d){
      let params = { 
        price:d.price ,
        startDatetime:str2time(d.range[0]),
        endDatetime:str2time(d.range[1])
      }

      this.$emit('ok' , params)
    },
  },
  render(){
    const { formData , loading , repairUsers} = this
    return (
      <div>
        <div class="modal-body">
          <sl-form label-width={60}>
            <sl-form-item label="时段">
              <TimePicker v-decorator={this.formData.range} placeholder="请选择时段" style="width: 100%" type="timerange"></TimePicker>
            </sl-form-item>
            <sl-form-item label="价格">
              <InputNumber min={0} v-decorator={this.formData.price} />
            </sl-form-item>
          </sl-form>
        </div>
        <div class="modal-footer">
          <Button loading={loading} on-click={this.$handleSubmit} type="primary">确定</Button>
        </div>
      </div>
    )
  }
}